module.exports = "\n<prettyjson *ngIf=\"data!==''\" [obj]=\"data\" style=\"text-align: initial;\"></prettyjson>"